import { PageNotFound } from "components/design/PageNotFound";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { parse } from "qs";
import { Redirect, useLocation } from "react-router-dom";

type RoleBasedRedirectProps = {
  adminUrl?: string;
  cpaUrl?: string;
  customerUrl?: string;
};

export const RoleBasedRedirect = ({
  adminUrl,
  cpaUrl,
  customerUrl,
}: RoleBasedRedirectProps) => {
  const { isAdmin, isCpa, isCustomer } = useRoleBasedView();
  const { link } = useConstructInternalLink();
  const { search } = useLocation();
  const keys = Object.keys(parse(search, { ignoreQueryPrefix: true }));

  if (isAdmin && adminUrl) {
    return <Redirect to={link(adminUrl, { keys })} />;
  }

  if (isCpa && cpaUrl) {
    return <Redirect to={link(cpaUrl, { keys })} />;
  }

  if (isCustomer && customerUrl) {
    return <Redirect to={link(customerUrl, { keys })} />;
  }

  return <PageNotFound />;
};
